import React from 'react';

const SyncManagerListingPage = React.lazy(() => import('pages/sync-manager/listing'));
const SyncManagerDetailsPage = React.lazy(() => import('pages/sync-manager/details'));

const policies = [{ resource: 'productInventories', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <SyncManagerListingPage />
  },
  {
    path: 'details/:syncTaskID',
    policies: policies,
    component: <SyncManagerDetailsPage />
  }
];